import React from "react";
import BlockquoteImg from "../../images/img-testimonial-Cabanillas.jpg";
import LazyLoad from 'react-lazyload';

export default function FlexprintCstestimonial() {
    return (
        <div className="cs-testimonial-section section-gap-large">
            <div className="container">
                <blockquote>
                    <h6>
                        The easiest way to sum up my relationship with the Rapidops team is that they make me and my team look good. They can become an extension of our internal team and translate our concepts and ideas into high-functioning software.
                    </h6>
                    <div className="blockquote-author d-flex align-v-center">
                        <div className="blockquote-image">
                            <LazyLoad>
                                <img src={BlockquoteImg} alt="Madison Palermo - Product Delivery" title="Madison Palermo - Product Delivery" />
                            </LazyLoad>
                        </div>
                        <div className="blockquote-detail">
                            <p>Chase Cabanillas</p>
                            <span>CIO, Flexprint</span>
                        </div>
                    </div>
                </blockquote>
            </div>
        </div>
    );
}

